import { CheckCircle2, ExternalLink, TrendingUp } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

function formatEur(n) {
  return new Intl.NumberFormat('es-ES', {
    style: 'currency', currency: 'EUR', minimumFractionDigits: 0,
  }).format(Number(n ?? 0));
}

/**
 * ProposeSalaryResult — shown after proponer_incremento_salarial generates a plan.
 * The plan is ready to be applied via actualizar_empleado (next tool call).
 */
export default function ProposeSalaryResult({ result }) {
  if (!result) return null;

  return (
    <div className="rounded-xl border border-success/30 bg-success/10 p-3 my-1 max-w-sm space-y-2">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0">
          <CheckCircle2 className="w-4 h-4 text-success shrink-0" />
          <div className="min-w-0">
            <p className="text-xs font-semibold text-foreground truncate">
              <TrendingUp className="w-3 h-3 inline text-indigo-500" /> {result.empleado}
            </p>
            <p className="text-[10px] text-muted-foreground">
              {formatEur(result.salario_actual)} → <strong>{formatEur(result.salario_propuesto)}</strong> (+{result.incremento_pct?.toFixed(1)}%)
            </p>
          </div>
        </div>
        {result.empleado_id && (
          <Link to={`/employee-detail?id=${result.empleado_id}`}>
            <Button size="sm" variant="outline"
              className="h-7 text-[11px] shrink-0 gap-1 border-success/30 text-success hover:bg-success/10">
              Ver
              <ExternalLink className="w-3 h-3" />
            </Button>
          </Link>
        )}
      </div>

      <div className="text-[10px] text-muted-foreground grid grid-cols-2 gap-2 border-t border-success/30 pt-2">
        <div>
          <p className="text-muted-foreground">Impacto anual</p>
          <p className="font-semibold tabular-nums">{formatEur(result.diff_anual)}</p>
        </div>
        <div>
          <p className="text-muted-foreground">Coste total c/ SS</p>
          <p className="font-semibold tabular-nums">{formatEur(result.coste_total_anual)}</p>
        </div>
      </div>
    </div>
  );
}
